import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const STORAGE_KEY = 'wowrolla_cookie_consent';

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) {
      setVisible(true);
    }
  }, []);

  const recordConsent = async (decision) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ decision, timestamp: new Date().toISOString() }));
    setVisible(false);
    try {
      await fetch('/api/public/consent-log', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 'cookie', decision, timestamp: new Date().toISOString() }),
      });
    } catch {
      // Non-blocking — consent already stored in localStorage
    }
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 border-t"
      style={{
        background: 'var(--bg-surface)',
        borderColor: 'var(--border-subtle)',
      }}
      role="region"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
    >
      <div className="container mx-auto px-6 py-4 flex flex-col md:flex-row items-start md:items-center gap-4">
        <p className="text-sm flex-1" style={{ color: 'var(--text-secondary)' }}>
          🍪 We use cookies for analytics and essential functionality. By using this site you accept our use of cookies.
          We are a Canadian company (Ottawa, ON) — see our{' '}
          <Link to="/privacy-policy" className="underline hover:text-cyber-yellow">
            Privacy Policy
          </Link>{' '}
          (PIPEDA compliant).
        </p>
        <div className="flex gap-3 flex-shrink-0">
          <button
            onClick={() => recordConsent('accepted')}
            className="btn-primary text-sm px-4 py-2"
          >
            Accept
          </button>
          <button
            onClick={() => recordConsent('declined')}
            className="text-sm px-4 py-2 border"
            style={{ borderColor: 'var(--border-subtle)', color: 'var(--text-secondary)' }}
          >
            Decline
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
